import React, {PureComponent} from 'react'
import cn from 'classnames'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import facebookImage from "../../img/icons/facebook.svg"
import twitterImage from "../../img/icons/twitter.svg"
import linkedinImage from "../../img/icons/linkedin.svg"
import Symbol from "../SVGSymbol"
import theme from "../../styles/theme"
import { getSiteUrl, getCurrentLocation } from '../../selectors'
import { stripBasePath } from '../../utils/pages'

class SocialLinks extends PureComponent {

    render() {
        const {classes, siteUrl, location, size="large", showLinkedIn} = this.props;
        var url = `${siteUrl}${stripBasePath(location.pathname)}`;
        const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
        const twitterUrl = `https://twitter.com/home?status=${encodeURIComponent(url)}`;
        const linkedinUrl = `http://www.linkedin.com/shareArticle?url=${encodeURIComponent(url)}`;

        return (
          <div className={classes.socialContainer}>
            <a className={classes.shareLink} href={facebookUrl} target="_blank"><Symbol icon={facebookImage} className={cn(classes.shareIcon, size)}/></a>
            <a className={classes.shareLink} href={twitterUrl} target="_blank"><Symbol icon={twitterImage} className={cn(classes.shareIcon, size)}/></a>
            {showLinkedIn && (<a className={classes.shareLink} href={linkedinUrl} target="_blank"><Symbol icon={linkedinImage} className={cn(classes.shareIcon, size)}/></a>)}
          </div>
        )
    }
}

const mapStateToProps = (state) => ({
    siteUrl: getSiteUrl(state),
    location: getCurrentLocation(state)
})

export default injectSheet(
    {
        container: {
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: 'center',
            [theme.breakpoint("tablet")]: {
                justifyContent: 'left'
            },
        },
        socialContainer: {
            lineHeight: 1
        },
        column: {
            display: "flex",
            flexDirection: "column",
            color: theme.colors.assent,
            fontSize: theme.font.info.fontSize,
            fontWeight: theme.font.info.fontWeight,
            lineHeight: theme.font.info.lineHeight,
            marginLeft: theme.spacing.small,
        },
        titleContainer: {
            flexGrow: 1,
            lineHeight: "1.2rem",
            [theme.breakpoint("tablet")]: {
                flexGrow: 0,
                minWidth: 180
            },
        },
        title: {
            fontWeight: "normal",
            color: theme.colors.black
        },
        image: {
            width: 56,
            height: 56,
            borderRadius: "50%",
            '&.small': {
                width: 42,
                height: 42,
            }
        },
        shareLink: {
            marginRight: '16px',
            textDecoration: "none",
            transition: "color 0.3s",
            color: theme.colors.assent,
            "&:hover": {
                color: theme.colors.primary,
            }
        },
        shareIcon: {
            height: 24,
            width: 24,
            '&.small': {
                height: 24,
                width: 24
            }
        }
    }
)(connect(mapStateToProps)(SocialLinks))



// WEBPACK FOOTER //
// ./src/components/Article/SocialLinks.js